import Loader from "app/components/Loader";
import * as React from "react";
import { lazyLoad } from "utils/loadable";

export const TeamSetting = lazyLoad(
  () => import("./index"),
  (module) => module.TeamSettingPages,
  {
    fallback: <Loader />,
  }
);
